import { render, staticRenderFns } from "./Large_screen.vue?vue&type=template&id=f4f79af2&scoped=true&"
import script from "./Large_screen.vue?vue&type=script&lang=js&"
export * from "./Large_screen.vue?vue&type=script&lang=js&"
import style0 from "./Large_screen.vue?vue&type=style&index=0&id=f4f79af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f79af2",
  null
  
)

export default component.exports